import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component({
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [ReactiveFormsModule, CommonModule,MatFormFieldModule,MatInputModule, MatDatepickerModule],
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.css'],
})
export class DateComponent implements OnInit {
  @Input() date: any;
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCLose: EventEmitter<any> = new EventEmitter<any>();
  updateDate: any;
  dateControl: FormControl;
  ngOnInit() {
    const dateOnly = this.date ? this.date.split(' ')[0] : null;
    
    // Initialize the form control with the value
    this.dateControl = new FormControl(dateOnly);
  
    this.dateControl.valueChanges.subscribe((value) => {
      this.updateDate = value;
    });
  }
  

  save() {
    this.onSave.emit(this.updateDate);
  }

  cancel() {
    this.onCLose.emit();
  }
}
